import React from 'react';
import { Link, LinkProps } from 'react-router-dom';
import ListItem from '@mui/material/ListItem';

interface Props {
  to: string;
  children: React.ReactNode;
  disabled?: boolean;
  className?: string;
  divider?: boolean;
  onClick?: () => void;
  style?: any;
  selected?: boolean;
}

/**
 * ListItemLink composes the Material UI `<ListItem>` with the react-router-dom
 * <Link> component. This means we do not have to do `onClick -> navigate` but
 * instead can pass a `to` prop to the `<ListItem>`.
 */
export default function ListItemLink({
  to,
  children,
  divider = true,
  ...props
}: Props): JSX.Element {
  const renderLink = React.useMemo(
    () =>
      React.forwardRef<any, Omit<LinkProps, 'to'>>((linkProps, ref) => (
        <Link ref={ref} to={to} {...linkProps} />
      )),
    [to],
  );

  return (
    <li>
      <ListItem button divider={divider} component={renderLink} {...props}>
        {children}
      </ListItem>
    </li>
  );
}
